"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AccordionItem = require("./AccordionItem.styles");
/**
 * A simple container used to wrap an `Accordion.Header` and `Accordion.Panel` set.
 *
 * @since 8.43.0
 */

var AccordionItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_AccordionItem.StyledAccordionItem, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.AccordionItem = AccordionItem;
AccordionItem.displayName = 'Accordion.Item';
AccordionItem.propTypes = {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any,
  children: _propTypes.default.node.isRequired
};